import React from 'react'
import { Campaign } from '@marketing-milk/interfaces'
import { OnPauseOrResumeAdObjectHandler } from '../../../../../app/services'
import { campaignHasEnded, campaignHasStarted } from '../../helpers/campaignForm.helpers'
import { AdsetsTable } from '../adsets/AdsetsTable'

export interface CampaignDetailsProps {
  campaign: Campaign
  onPauseOrActivate: OnPauseOrResumeAdObjectHandler
}

// Expanding a campaign shows what is inside it — its adsets, and their ads. The campaign's own
// settings are read and changed in the edit drawer, so repeating them here only pushed the
// adsets below the fold.
export function CampaignExpandDetails({ campaign, onPauseOrActivate }: CampaignDetailsProps) {
  return (
    <div key={campaign.id} className="border-mm-primary-200 w-full border-l-4 py-4 pl-6 pr-4">
      <AdsetsTable
        campaign={campaign}
        campaignHasEnded={campaignHasEnded(campaign.endTime)}
        isFutureCampaign={!campaignHasStarted(campaign.startTime)}
        onPauseOrResume={onPauseOrActivate}
      />
    </div>
  )
}
